import { defineStyleConfig } from '@chakra-ui/react';

const Textarea = defineStyleConfig({
  variants: {
    outline: (props) => ({
        bg: props.colorMode === 'dark' ? 'surface.darkContent' : 'surface.content',
        borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
        _hover: {
            borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focusVisible: {
            borderColor: 'brand.blue.500',
            boxShadow: 'focus',
        },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Textarea;